/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Organizationslugplaceholder3Inputs */

const zh_organizationsettings_organizationslugplaceholder3 = /** @type {(inputs: Organizationsettings_Organizationslugplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`my-organization`)
};

const en_organizationsettings_organizationslugplaceholder3 = /** @type {(inputs: Organizationsettings_Organizationslugplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`my-organization`)
};

const es_organizationsettings_organizationslugplaceholder3 = /** @type {(inputs: Organizationsettings_Organizationslugplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mi-organizacion`)
};

/**
* | output |
* | --- |
* | "my-organization" |
*
* @param {Organizationsettings_Organizationslugplaceholder3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_organizationslugplaceholder3 = /** @type {((inputs?: Organizationsettings_Organizationslugplaceholder3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Organizationslugplaceholder3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_organizationslugplaceholder3(inputs)
	if (locale === "en") return en_organizationsettings_organizationslugplaceholder3(inputs)
	return es_organizationsettings_organizationslugplaceholder3(inputs)
});
export { organizationsettings_organizationslugplaceholder3 as "organizationSettings_organizationSlugPlaceholder" }